// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2jsZ1","addWidgetButton":"Header_addWidgetButton__INARe","dashboardTabs":"Header_dashboardTabs__2KBMI","active":"Header_active__3U40x"};